import LicenseAccounts from "common/components/LicenseAccounts";
import { Tag } from "common/components/ui/Tag";
import type { WorkspaceAccount } from "common/types";

import type { JSX } from "react";

export default function SubscriptionCardSeatsSummary({
  accounts,
  availableSeatsCount,
  extraTagComponent,
}: {
  accounts: WorkspaceAccount[];
  availableSeatsCount: number;
  extraTagComponent?: JSX.Element;
}) {
  return (
    <div className="flex flex-col items-start gap-y-1">
      <div className="flex items-center gap-x-1">
        <h5 className="text-sm-medium text-black-500">
          Seats on this workspace
        </h5>
        <Tag variant="tertiary" size="sm">
          {accounts.length} / {availableSeatsCount} used
        </Tag>
        {extraTagComponent}
      </div>
      <LicenseAccounts accounts={accounts} />
    </div>
  );
}
